import { all, call, put, SagaReturnType, takeLatest } from 'redux-saga/effects';

import * as manageEpisodeActions from '@/admin/components/modals/manageEpisodeModal/Actions';
import * as episodesActions from '@/admin/pages/studyGoBridgeEpisodes/Actions';
import * as errorHandlerActions from '@/components/errorHandler/Actions';
import { manageEpisodeActionTypes } from '@/admin/components/modals/manageEpisodeModal/Constants';
import { processRequest } from '@/services/Api';

import type {
	GetEpisodeDataRequestAction,
	ManageEpisodeRequestAction,
} from '@/admin/components/modals/manageEpisodeModal/Actions';
import type { Episode } from '@/admin/components/modals/manageEpisodeModal/types';

export default function* manageEpisodeSagas(): Generator {
	yield all([
		takeLatest(
			manageEpisodeActionTypes.GET_ADMIN_EPISODE_DATA_REQUEST,
			handleGetEpisodeDataRequest,
		),
		takeLatest(
			manageEpisodeActionTypes.MANAGE_ADMIN_EPISODE_REQUEST,
			handleManageEpisodeRequest,
		),
	]);
}

interface GetEpisodeDataResponse {
	data: {
		study_go_bridge_episode: Episode;
	};
}

export function* handleGetEpisodeDataRequest(action: GetEpisodeDataRequestAction) {
	try {
		const { episodeId } = action.payload;

		const response: SagaReturnType<typeof processRequest> = yield call(
			processRequest,
			`admin/study_go_bridge/episodes/${episodeId}`,
		);

		const episodeData = (response as GetEpisodeDataResponse).data.study_go_bridge_episode;

		yield put(manageEpisodeActions.getEpisodeDataSuccess(episodeData));
	} catch (e) {
		yield put(manageEpisodeActions.getEpisodeDataError());
	}
}

export function* handleManageEpisodeRequest(action: ManageEpisodeRequestAction) {
	try {
		const { episodeId, name, unlocked_at, password, callback } = action.payload;

		if (episodeId) {
			yield call(processRequest, `admin/study_go_bridge/episodes/${episodeId}`, 'PUT', {
				study_go_bridge_episode: { name, unlocked_at, password },
			});
		} else {
			yield call(processRequest, 'admin/study_go_bridge/episodes', 'POST', {
				study_go_bridge_episode: { name, unlocked_at, password },
			});
		}

		callback && callback();

		yield put(manageEpisodeActions.manageEpisodeSuccess());
		yield put(episodesActions.getEpisodesRequest());
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(manageEpisodeActions.manageEpisodeError());
	}
}
